











import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    fluorescentProperties: {
      type: Array as () => Object[],
      required: false,
      default: undefined,
    },
  },
  setup({ fluorescentProperties }) {
    const fluorescentsList = fluorescentProperties?.map((item: any) => item.text)

    return { fluorescentsList }
  },
})
